var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EEEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C15.38 10 13.25 12.13 13.25 14.75C13.25 17.32 15.26 19.4 17.88 19.49C17.96 19.48 18.04 19.48 18.1 19.49C18.12 19.49 18.13 19.49 18.15 19.49C18.16 19.49 18.16 19.49 18.17 19.49C20.73 19.4 22.74 17.32 22.75 14.75C22.75 12.13 20.62 10 18 10Z",
    fill: "#FF7D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 22.15C20.29 20.29 15.74 20.29 12.93 22.15C11.66 23 10.96 24.15 10.96 25.38C10.96 26.61 11.66 27.75 12.92 28.59C14.32 29.53 16.16 30 18 30C19.84 30 21.68 29.53 23.08 28.59C24.34 27.74 25.04 26.6 25.04 25.36C25.03 24.13 24.34 22.99 23.08 22.15Z",
    fill: "#FF7D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.99 15.34C29.15 17.28 27.77 18.98 25.86 19.21C25.85 19.21 25.85 19.21 25.84 19.21H25.81C25.75 19.21 25.69 19.21 25.64 19.23C24.67 19.28 23.78 18.97 23.11 18.4C24.14 17.48 24.73 16.1 24.61 14.6C24.54 13.79 24.26 13.05 23.84 12.42C24.22 12.23 24.66 12.11 25.11 12.07C27.07 11.9 28.82 13.36 28.99 15.34Z",
    fill: "#FF7D38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.99 24.59C30.91 25.56 30.29 26.4 29.25 26.97C28.25 27.52 26.99 27.78 25.74 27.75C26.46 27.1 26.88 26.29 26.96 25.43C27.06 24.19 26.47 23 25.29 22.05C24.62 21.52 23.84 21.1 22.99 20.79C25.2 20.15 27.98 20.58 29.69 21.96C30.61 22.7 31.08 23.63 30.99 24.59Z",
    fill: "#FF7D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSCard1);
export default __webpack_public_path__ + "static/media/s_card_1.fb29c6c64412fc3146a37986976120fe.svg";
export { ForwardRef as ReactComponent };